import { LessonStep } from '../../../types/asset/lesson.types.ts';
import { LessonTask } from '../../../types/asset/lesson.types.ts';
import { ScriptProcessingResult } from '../../../types/asset/script.types.ts';

import { getSentryUtil } from '../../monitoring/sentry.util.ts';

export abstract class BaseScriptsProcessor {
  public abstract process(part: string, task: LessonTask, step: LessonStep): ScriptProcessingResult;

  protected handleError(error: Error, task: LessonTask, step: LessonStep): void {
    getSentryUtil().trackError(error, {
      letters: task.letters?.join(','),
      words: task.words?.join(','),
      rhymingSounds: task.rhymingSounds?.join(','),
      step: step.index,
    });
  }
}
